export default "__VITE_ASSET__BJOyHzoN__"